export default __webpack_public_path__ + "static/media/map1.c995a126.png";